export default {
  fontFamily: "cn-font-family",
  classLang: "cn",
  headlist: [
    // {
    //   text: "首页",
    //   url: "/",
    // },
    {
      text: "交易",
      url: "",
      menu: [
        {
          tit: "交易产品",
          list: [
            {
              text: "衍生品交易",
              url: "/trading-product/forex/",
            },
            {
              text: "贵金属及能源",
              url: "/trading-product/commodity/",
            },
            {
              text: "全球股指",
              url: "/trading-product/index-cfds/",
            },
            {
              text: "美国股票",
              url: "/trading-product/share-cfds/",
            },
            {
              text: "ETF",
              url: "/trading-product/etf/",
            },
            // {
            //   text: "数字资产",
            //   url: "/tradingproduct?index=5",
            // },
          ],
        },
        {
          tit: "账号&条件",
          list: [
            {
              text: "交易账号",
              url: "/TradingAccount",
            },
            // {
            //   text: "交易产品",
            //   url: "/tradingproduct",
            // },
            {
              text: "杠杆与保证金",
              url: "/leverage-margin",
            },
            {
              text: "存款取款",
              url: "/funding",
            },
            {
              text: "股息",
              url: "/dividend",
            },
            {
              text: "机构服务",
              url: "/service",
            },
            {
              text: "金融科技",
              url: "/technology",
            },
          ],
        },
        {
          tit: "交易工具",
          list: [
            {
              text: "EBC App",
              url: "/mobile",
            },
            {
              text: "MT4下载",
              url: "/MT4",
            },
            {
              text: "MT5下载",
              url: "/MT5",
            },
             {
              text: "PAMM",
              url: "/PAMM",
            },
            {
              text: "分析工具与指标",
              url: "/tools",
            },
           {
              text: "订单流工具",
              url: "/orderflow",
            },
            {
              text: "市场分析",
              url: "/market-analysis",
            },
          ],
        },
      ],
    },
    {
      text: "交易学院",
      url: "/jinrong",
    
    },

    {
      text: "关于EBC",
      url: "",
      menu: [
        {
          tit: "关于EBC",
          list: [
            {
              text: "EBC简介",
              url: "/about-us",
            },
             {
              text: "奖项与荣誉",
              url: "/about-us/awards/",
            },
            {
              text: "社会责任",
              url: "/ESG",
            },
            {
              text: "EBC动态",
              url: "/LearningCenter?tabId=1",
            },
            {
              text: "公告通知",
              url: "/LearningCenter?tabId=6&tab=4",
            },
          ],
        },
        {
          tit: "合作伙伴",
          list: [
            {
              text: "与巴萨共赢",
              url: "/FCB",
            },
            {
            text: "牛津大学",
              url: "/partners/oxford",
            },
            {
              text: "合作伙伴计划",
              url: "/affiliate-programmes",
            },
           
          ],
        },
        {
          tit: "客户服务",
          list: [
            {
              text: "帮助中心",
              url: "https://support.ebchelp.com/hc/zh-cn",
              blankTarget:true
            },
            {
            text: "官方验证",
              url: "/official-verification",
            },
          ],
        },
      ],
    },
    {
      text: "最新活动",
      url: "/activity",
      // menu: [
      //   {
      //     tit: "EBC热门活动",
      //     list: [
      //       {
      //         text: "EBC全球百万美金交易大赛Ⅱ",
      //         url: "/million-dollar-challenge-2",
      //       },
            
      //       {
      //         text: "基金经理成长计划",
      //         url: "/pay",
      //       },{
      //         text: "积分商城",
      //         url: "/activity?index=2",
      //       },{
      //         text: "更多活动",
      //         url: "/activity",
      //       },
           
      //     ],
      //   },
      // ],
    },
    {
      text: "跟单社区",
      url: "/from0tohero",
    },
  ],
  FCA开户: "FCA开户",
  立即开户: "立即开户",
  登录: "登录",
  官方验证: "官方验证",
  帮助中心: "帮助中心",
  帮助中心Url: "https://support.ebchelp.com/hc/zh-cn",
};
